<template>
  <div>
    <div class="grey lighten-5 input-container">
      <v-row>
        <v-col cols="12" md="3" class="d-none-mob"></v-col>
        <v-col cols="12" md="3" class="d-none-mob"></v-col>
        <v-col cols="12" md="3" class="d-none-mob"></v-col>
        <v-col v-if="permissions.includes('CAN_EXPORT_CITY_WISE_DOCTORS')" cols="12" md="3">
          <div class="mt-3 ml-4 text-end mob-t-left">
            <v-btn @click="downloadCsv()" class="btn btn-primary mr-4 mt-4">Export</v-btn>
          </div>
        </v-col>
      </v-row>

      <loader v-if="showLoader"></loader>
      <v-col cols="12" class="mt-2">
        <div class="table-div">
          <table class="table table-responsive userlistTable-typ1">
            <thead>
              <tr class="table-success">
                <th scope="col">City</th>
                <th scope="col">Number of Doctors</th>
                <th scope="col">Number of Verifed Doctors</th>
              </tr>
            </thead>

            <tbody v-if="!isEmpty">
              <tr v-for="(list, i) in doctorList" :key="i">
                <td>
                  <div>
                    {{
                    list._id.city
                    ? list._id.city
                    : list._id.city === ""
                    ? "Empty City String"
                    : "No City Specified"
                    }}
                  </div>
                </td>
                <td>
                  <div>{{ list.total_doctors }}</div>
                </td>
                <td>
                  <div>{{ list.is_user_verified }}</div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="isEmpty">
              <tr>
                <td colspan="5">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <pagination
        class="mx-3 pagination-block"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
        v-if="!isEmpty"
      />
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
import formats from "@/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
const loader = () => import("@/components/loader.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const pagination = () => import("@/views/common/Pagination");
export default {
  components: {
    loader,
    Datepicker,
    pagination
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      formats,
      dayJS,
      showLoader: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 0,
      doctorList: [],
      isEmpty: false,
      modalType: "edit",
      total: 0
    };
  },
  mounted() {
    this.getDoctors();
  },
  methods: {
    //  page change event call
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getDoctors();
    },

    // getDoctors Data
    getDoctors() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        record_per_page: this.recordPerPage
      };
      let url = `${config.BASE_URL}api/v2/admin/reports/citywise-doctor-list`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.doctorList = response.body.data.list;
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.doctorList = [];
            this.isEmpty = true;
          }
        }
      });
    },

    // download current page as csv
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        record_per_page: this.recordPerPage
      };
      let url = `${config.BASE_URL}api/v2/admin/reports/citywise-doctor-list-csv`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },

    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
};
</script>
<style lang="scss">
.table th,
.table td {
  vertical-align: middle;
}
</style>